import devConfig from './development';
import prodConfig from './production';

export default devConfig; //process.env.NODE_ENV === 'production' ? prodConfig : devConfig;
